import React from "react";

export const en = {
  body: (
    <div>
      <h3>FloraVeg.EU</h3>
      <p>FloraVeg.EU (
      <a href="https://floraveg.eu/">https://floraveg.eu/</a>) je
       is an online database of European flora and vegetation data prepared for various projects of the Vegetation Science Group.  It uses the Pladias database platform.
</p>
<p>The Flora part of the database focuses on native and naturalized flora occurring in Europe. Species are characterized by their biological traits, origin, ecological indicator values and their occurrence in habitat and vegetation types.
</p>
<p>
The Vegetation part of the database contains the phytosociological (syntaxonomic) classification of European vegetation based on EuroVegChecklist (Mucina et al. 2016, Applied Vegetation Science). Data on structure, ecology and biogeography, distribution maps and photographs are provided for individual vegetation types.
</p>
<p>
The Habitat part of the database presents the terrestrial part of the EUNIS Habitat Classification managed by the European Environment Agency. Brief descriptions, characteristic species combinations, distribution maps and links to phytosociological alliances are provided for individual habitat types.
</p>
	</div>
  )
};

export const cz = {
  body: (
    <div>
      <h3>FloraVeg.EU</h3>
      <p>FloraVeg.EU (
      <a href="https://floraveg.eu/">https://floraveg.eu/</a>) je
       je online databáze údajů o evropské flóře a vegetaci připravená pro různé projekty pracovní skupiny Výzkum vegetace. Využívá databázovou platformu Pladias.
</p>
<p>Část databáze „Flora“ se zaměřuje na původní a naturalizovanou flóru vyskytující se v Evropě. Druhy jsou charakterizovány svými biologickými znaky, původem, hodnotami ekologických ukazatelů a jejich výskytem na stanovištích a vegetačních typech.
</p>
<p>
Vegetační část databáze obsahuje fytocenologickou (syntaxonomickou) klasifikaci evropské vegetace na základě EuroVegChecklist (Mucina et al. 2016, Applied Vegetation Science). Pro jednotlivé typy vegetace jsou uvedeny údaje o struktuře, ekologii a biogeografii, mapy rozšíření a fotografie.
</p>
<p>
Část databáze „Habitat“ představuje terestrickou část EUNIS Habitat Classification řízené Evropskou agenturou pro životní prostředí. U jednotlivých typů stanovišť jsou uvedeny stručné popisy, charakteristické kombinace druhů, mapy rozšíření a odkazy na fytocenologické svazy.
</p>
	</div>
  )
};
